
<div class="dynamic-field-menu">
  <slot name="header"></slot>
  <slot name="body"></slot>
  <slot name="footer"></slot>
</div>
